// Theme Loader - Initialize Midnight Judicial theme before React mount
(function() {
  try {
    document.body.className = 'default-theme';
    document.documentElement.style.setProperty('--background-color', '#09090d');
    document.documentElement.style.setProperty('--body-bg-color', '#09090d');
    document.documentElement.style.setProperty('--card-background', 'rgba(22, 20, 34, 0.85)');
    document.documentElement.style.setProperty('--text-color', '#f8fafc');
    document.documentElement.style.setProperty('--primary-color', '#d4af37');
  } catch (e) {
    console.error('Theme loader initialization failed:', e);
  }
})();

const themeLoader = {};
export default themeLoader;